import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styles from './NavBar.module.scss';
import SearchIcon from '@mui/icons-material/Search';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

function NavBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };

  return (
    <nav className={`${styles.navBar} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.logoContainer} onClick={() => navigate('/Home')}>
        <div className={styles.logoMark}>
          <img 
            src='/assets/logo-simplificada.png'
            alt="Sergipanidade" 
            className={styles.logoImage} 
          />
        </div>
        <span className={styles.brandText}>ergipanidade</span>
      </div>

      <button
        className={styles.mobileToggle}
        onClick={toggleMobileMenu}
        aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={mobileMenuOpen}
      >
        {mobileMenuOpen ? <CloseIcon className={styles.icon} /> : <MenuIcon className={styles.icon} />}
      </button>

      <ul className={`${styles.menu} ${mobileMenuOpen ? styles.menuOpen : ''}`}>
        <li>
          <NavLink 
            to="/Home" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.activeLink}` : styles.navLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Início
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/mapa" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.activeLink}` : styles.navLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Mapa
          </NavLink>
        </li>
        <li>
          <NavLink 
            to="/estabelecimentos" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.activeLink}` : styles.navLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Estabelecimentos
          </NavLink>
        </li>
        {/* <li>
          <NavLink 
            to="/chat" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.activeLink}` : styles.navLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Chat
          </NavLink>
        </li> */}
        <li>
          <NavLink 
            to="/roteiro" 
            className={({ isActive }) => isActive ? `${styles.navLink} ${styles.activeLink}` : styles.navLink}
            onClick={() => setMobileMenuOpen(false)}
          >
            Roteiro
          </NavLink>
        </li>
      </ul>

      
      <div className={styles.actions}>
        <div className={styles.iconWrapper}>
          <SearchIcon className={styles.icon} />
        </div>
        <div className={styles.iconWrapper} onClick={() => navigate('/perfil')}>
          <AccountCircleOutlinedIcon className={styles.icon} />
        </div>
      </div>
    </nav>
  );
};

export default NavBar;